// extracted by mini-css-extract-plugin
var _1 = "oswccu3Y";
export { _1 as "logo" }
